import { render, staticRenderFns } from "./25.vue?vue&type=template&id=084488e3&scoped=true&"
var script = {}
import style0 from "./25.vue?vue&type=style&index=0&id=084488e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084488e3",
  null
  
)

export default component.exports